import {Pagination, Table} from "antd";
import ProductCategoryAction from "./ProductCategoryAction";
import {useContext} from "react";
import {AppContext} from "~/context/AppProvider";

function ProductCategoryTable({items = [], pagination, onPaginationChange, onEdit, onDelete, can}) {

	const {tableHeight} = useContext(AppContext);

	let columns = [
		{ title: 'Tên danh mục', dataIndex: 'name', key: "name", width: '300px', render: (_, item) => (
			<div><b>{item?.name}</b></div>
		)},
		{ title: 'Danh mục cha', dataIndex: 'parent_id', key: "parent_id", width: '150px'},
		{ title: '#', dataIndex: 'action', key: "action", width: '150px', render: (_, item) => (
			<ProductCategoryAction key={item.id}
                            item={item}
                            onEdit={onEdit}
                            onDelete={onDelete}
                            can={can}
			/>
		)},
	];

	const dataSource= items.map(row => ({
		key: row.id,
		...row
	}));

	return (
		<div className="table-wrapper">
			<div className="table-box">
				<Table
					columns={columns}
					dataSource={dataSource}
					scroll={{ y:tableHeight, x: 'max-content' }}
					pagination={false}
				/>
			</div>
			<Pagination current={pagination?.page} defaultCurrent={1} defaultPageSize={20} pageSize={pagination?.limit} total={pagination?.total} onChange={onPaginationChange}  showSizeChanger={false} />
		</div>
	)
}

export default ProductCategoryTable;
